<div class='PartnerControl'>
  <app-select
    (selection)='onPartnerSelect($event)'
    *ngIf="column.account_role !== 'vsm' && column.account_role !== 'master'"
    [defaultValue]='column.partner_id || null'
    [items]='getPartners()'
    [label]="'Select partner'"></app-select>
  <div class='d-flex flex-row align-items-center justify-content-center'>
    <app-button *ngIf="column.account_role === 'partner'" [Click]='viewRepButtonProperties.onClick'
                [color]='viewRepButtonProperties.color'
                [size]='viewRepButtonProperties.size' [style]='viewRepButtonProperties.style'
                [text]='viewRepButtonProperties.text' class='mt-2'></app-button>
    <mat-icon (click)='resetPartner()' *ngIf='column.partner_id'>close</mat-icon>
  </div>
</div>
